import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { useState, useEffect } from "react"
import { Link } from "gatsby"
import { Box, ArrowLeftCircle, Folder, EmptyPage } from "iconoir-react"
import * as css from "../styles/navigation.module.scss"

const Navigation = (props) => {
	const data = useStaticQuery(graphql`
		query {
			allMdx {
				nodes {
					frontmatter {
						category
						name
						slug
					}
				}
			}
		}
	`)

	const [onContributors, setOnContributors] = useState(false)
	const [onArtworks, setOnArtworks] = useState(false)

	useEffect(() => {
		if (props.pageTitle === "contributors") {
			setOnContributors(true)
		} else if (props.pageTitle === "artworks") {
			setOnArtworks(true)
			setOnContributors(false)
		} else {
			setOnContributors(false)
			setOnArtworks(false)
		}
	}, [onContributors])

	return (
		<nav>
			<ul>
				<li>
					<Link to="../">
						<ArrowLeftCircle width={`1.2em`} height={`1.2em`} strokeWidth={`2px`} />
					</Link>
				</li>
				<li>
					<Link to="/">
						<Box width={`1.2em`} height={`1.2em`} strokeWidth={`2px`} />
						<span>EXHIBITION STATEMENT</span>
					</Link>
				</li>
				<li>
					<Link to="/contributors">
						<Folder width={`1.2em`} height={`1.2em`} strokeWidth={`2px`} />{" "}
						<span>contributors</span>
					</Link>
				</li>
				<ul className={css.navContributorsList} data-oncontributors={onContributors}>
					{data.allMdx.nodes.map((node) => {
						if (node.frontmatter.category === "contributor") {
							return (
								<li>
									<EmptyPage
										width={`1.2em`}
										height={`1.2em`}
										strokeWidth={`2px`}
										color={`#fdd000`}
									/>{" "}
									<Link to={`/contributors/${node.frontmatter.slug}`}>
										{node.frontmatter.name}
									</Link>
								</li>
							)
						} else {
							return null
						}
					})}
				</ul>
				<li>
					<Link to="/artworks">
						<Folder
							width={`1.2em`}
							height={`1.2em`}
							strokeWidth={`2px`}
							color={`#fdd000`}
						/>{" "}
						<span>artworks</span>
					</Link>
				</li>
				<ul className={css.navArtworksList} data-onartworks={onArtworks}>
					{data.allMdx.nodes.map((node) => {
						if (node.frontmatter.category === "artwork") {
							return (
								<li>
									<EmptyPage
										width={`1.2em`}
										height={`1.2em`}
										strokeWidth={`2px`}
										color={`#fdd000`}
									/>{" "}
									<Link to={`/artworks/${node.frontmatter.slug}`}>
										{node.frontmatter.name}
									</Link>
								</li>
							)
						} else {
							return null
						}
					})}
				</ul>
				<li>
					<Link to="/interviews">
						<EmptyPage width={`1.2em`} height={`1.2em`} strokeWidth={`2px`} />{" "}
						<span>interviews</span>
					</Link>
				</li>
				<li>
					<Link to="/worklab">
						<EmptyPage width={`1.2em`} height={`1.2em`} strokeWidth={`2px`} />{" "}
						<span>worklab</span>
					</Link>
				</li>
				<li>
					<Link to="/screening-and-discussion">
						<EmptyPage width={`1.2em`} height={`1.2em`} strokeWidth={`2px`} />
						<span>screening &{"\n"}discussion</span>
					</Link>
				</li>
			</ul>
		</nav>
	)
}

export default Navigation
